module.exports = __webpack_public_path__ + "static/media/login.f20c9160.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/background/login.png
// module id = 559
// module chunks = 0